import React, { useEffect, useState } from 'react';
import { Card, ProgressBar, Button, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faMedal } from '@fortawesome/free-solid-svg-icons';
import BookingService from './bookings/BookingService';
import DirectoryService from '../directory/DirectoryService';
import ClassService from './classes/ClassService';
import { useNavigate } from 'react-router-dom';
const getDaysLeftInMonth = () => {
  const today = new Date();

  const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  const diffTime = lastDayOfMonth - today;

  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};
const MonthlyChallengeCard = ({ data }) => {
  const navigate = useNavigate();
  const [challenge, setChallenge] = useState();
  const [userRanking, setUserRanking] = useState();
  useEffect(() => {
    const loadMonthlyChallengeCard = async () => {
      const profile = JSON.parse(localStorage.getItem('profile'));
      const { identifier, accountIdentifier } = profile;
      try {
        const bookings = await BookingService.retrieveAllBookingsByUser(identifier);
        const totalParticipants = await
          DirectoryService.retrieveProfilesByAccountIdentifier(
            accountIdentifier
          );

        const leaderboard = await ClassService.retrieveleaderboard();
        const userRanking = leaderboard.filter(r=>r?.identifier === profile?.identifier);
        setUserRanking(userRanking[0]);

        const totalBookingsThisMonth = bookings.filter(booking => {
          const bookingDate = new Date(booking.date);
          const currentYear = new Date().getFullYear();
          const currentMonth = new Date().getMonth();
          return (
            bookingDate.getFullYear() === currentYear &&
            bookingDate.getMonth() === currentMonth
          );
        }).length;
        const monthlyChallenge = {
          title: month + ' Challenge',
          description: 'Complete 20 classes',
          progress: totalBookingsThisMonth,
          target: 20,
          percentage: Math.round((totalBookingsThisMonth / 20) * 100),
          rank: userRanking[0]?.rank,
          totalParticipants: totalParticipants.length,
          daysLeft: getDaysLeftInMonth()
        };
        console.log('Montly Challenge', monthlyChallenge);
        setChallenge(monthlyChallenge);
      } catch (error) {
        console.log(error);
      }
    };
    loadMonthlyChallengeCard();
    const month = new Date().toLocaleString('en-us', {
      month: 'short',
      year: 'numeric'
    });
  }, []);
  return (
    <>
      {challenge && (
        <Card className="h-100 isDark border-0 shadow-sm wod-dark-card">
          <Card.Body>
            <div className="d-flex justify-content-between align-items-start mb-3">
              <div>
                <div className="d-flex align-items-center mb-2">
                  <FontAwesomeIcon
                    icon={faTrophy}
                    className="text-warning me-2"
                    size="lg"
                  />
                  <h5 className="mb-0 fw-bold">Monthly Challenge</h5>
                </div>
                <h6 className="text-white-75 mb-1">{challenge.title}</h6>
                <small className="text-white-50">{challenge.description}</small>
              </div>
              <Badge bg="warning" text="dark" className="fs-1 m-1">
                {challenge.daysLeft} days left
              </Badge>
            </div>

            <div className="mb-3">
              <div className="d-flex justify-content-between mb-2">
                <span className="text-white-75">Progress</span>
                <span className="fw-bold text-warning">
                  {challenge.progress}/{challenge.target}
                </span>
              </div>
              <ProgressBar
                now={challenge.percentage}
                variant="warning"
                style={{ height: '12px' }}
              />
            </div>

            <div
              className="d-flex justify-content-between align-items-center p-3 rounded mb-3"
              style={{ backgroundColor: 'rgba(255,255,255,0.05)' }}
            >
              {userRanking && (<div>
                <small className="text-white-50 d-block">Your Rank</small>
                <div className="d-flex align-items-center">
                  <FontAwesomeIcon
                    icon={faMedal}
                    className="text-warning me-2"
                  />
                  <span className="fs-4 fw-bold">#{challenge.rank}</span>
                  <small className="text-white-50 ms-2">
                    of {challenge.totalParticipants}
                  </small>
                </div>
              </div>)}
              {challenge.prize && (
                <div className="text-end">
                <small className="text-white-50 d-block">Prize</small>
                <small className="text-warning fw-semibold">
                  {challenge.prize}
                </small>
              </div>)}
            </div>

            <Button variant="warning" className="w-100 fw-semibold" onClick={() => navigate('/app/wod/leaderboard')}>
              View Leaderboard
            </Button>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default MonthlyChallengeCard;
